'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$QuantityEquals$$anon$5(f$2, outer) {
  this.Y3 = null;
  this.ahD = null;
  this.Y3 = f$2;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.ahD = outer;
}
export { $c_Lapp_data_FormQuantity$QuantityEquals$$anon$5 as $c_Lapp_data_FormQuantity$QuantityEquals$$anon$5 };
$p = $c_Lapp_data_FormQuantity$QuantityEquals$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$QuantityEquals$$anon$5;
/** @constructor */
function $h_Lapp_data_FormQuantity$QuantityEquals$$anon$5() {
}
export { $h_Lapp_data_FormQuantity$QuantityEquals$$anon$5 as $h_Lapp_data_FormQuantity$QuantityEquals$$anon$5 };
$h_Lapp_data_FormQuantity$QuantityEquals$$anon$5.prototype = $p;
$p.auj = (function(b1, b2) {
  return this.ahD.auj(this.Y3.h(b1), this.Y3.h(b2));
});
$p.aui = (function(b1, b2) {
  return this.ahD.aui(this.Y3.h(b1), this.Y3.h(b2));
});
var $d_Lapp_data_FormQuantity$QuantityEquals$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$QuantityEquals$$anon$5, "app.data.FormQuantity$QuantityEquals$$anon$5", ({
  DH: 1,
  jv: 1
}));
export { $d_Lapp_data_FormQuantity$QuantityEquals$$anon$5 as $d_Lapp_data_FormQuantity$QuantityEquals$$anon$5 };
//# sourceMappingURL=app.data.-Form-Quantity$-Quantity-Equals$$anon$5.js.map
